import { render, staticRenderFns } from "./sizhenhecan.vue?vue&type=template&id=71b8651e&"
import script from "./sizhenhecan.vue?vue&type=script&lang=ts&"
export * from "./sizhenhecan.vue?vue&type=script&lang=ts&"
import style0 from "./sizhenhecan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports